export const tourDataArray = [
  {
    country: 'USA',
    state: 'NV',
    city: 'Las Vegas',
    dateArriving: '1/20 - 1/26, 2026',
    description:
      'In Sin City, I am the main attraction. Hypnosis, indulgence, and neon sin — gamble your mind on Me.',
  },
];
